<template>
  <div class="notifications">
    <transition-group
      name="notification"
      tag="div">
      <notifications-item
        v-for="notification in errorNotifications"
        :key="notification.id"
        :notification="notification"
        class="notifications-item"
        :class="notification.entity"
        @hide="hideNotification" />
    </transition-group>

    <transition
      name="notification"
      tag="div">
      <notifications-slider
        v-if="filteredNotifications.length"
        :notifications="filteredNotifications">
        <template #default="{ notification }">
          <notifications-item
            :notification="notification"
            class="notifications-item"
            :class="notification.entity"
            @hide="hideNotification" />
        </template>
      </notifications-slider>
    </transition>
  </div>
</template>

<script>
import {
  // eslint-disable-next-line no-unused-vars
  mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';
import TabManagerModel from 'Models/TabManagerModel';
import NotificationsItem from './NotificationsItem.vue';
import NotificationsSlider from './NotificationsSlider.vue';

export default {
  name: 'Notifications',

  components: {
    NotificationsItem,
    NotificationsSlider,
  },

  computed: {
    ...mapState(['tabManager']),
    ...mapState('notifications', ['unread', 'notifications']),
    ...mapState(['userDevice']),

    errorNotifications() {
      return this.notifications.filter((notification) => notification.entity === 'error');
    },

    filteredNotifications() {
      return this.notifications.filter((notification) => notification.entity !== 'error');
    },
  },

  watch: {
    filteredNotifications: {
      handler(newValue) {
        if (newValue.length) {
          document.body.classList.add('has-notifications');
        } else {
          document.body.classList.remove('has-notifications');
        }
      },
    },
  },

  mounted() {
    this.tabManager.listenEvent(TabManagerModel.EVENTS.NOTIFICATIONS.CLOSE, this.mutateRemoveNotification);
  },

  beforeDestroy() {
    this.tabManager.removeListener(TabManagerModel.EVENTS.NOTIFICATIONS.CLOSE);
  },

  methods: {
    ...mapMutations('notifications', ['mutateRemoveNotification']),

    hideNotification(notificationId) {
      this.tabManager.broadcast(TabManagerModel.EVENTS.NOTIFICATIONS.CLOSE, notificationId);
      this.mutateRemoveNotification(notificationId);
    },
  },
};
</script>

<style lang="scss" scoped>
  .notifications {
    position: fixed;
    bottom: 0;
    right: 0;
    margin: 0 24px 24px;
    z-index: 1050;
  }

  .notification-enter-active {
    transition: transform .35s cubic-bezier(0.0, 0.0, 0.2, 1), opacity .35s cubic-bezier(0.0, 0.0, 0.2, 1);
  }
  .notification-leave-active {
    transition: transform .3s cubic-bezier(0.4, 0.0, 1, 1), opacity .3s cubic-bezier(0.4, 0.0, 1, 1);
  }

  .notification-enter, .notification-leave-to /* .list-leave-active до версии 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
  }

  .notifications-item.error {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color:  rgba($color--preset-bad, .85);
    max-width: none;
    padding: 0;
    margin: 0;
    border-radius: 0;
  }

  @media screen and #{$screen-less-than-1024} {
    .notifications {
      margin: 0;
      width: 100%;
      z-index: 2147483010;
      top: 0;
      bottom: initial;
    }

    .notification-enter, .notification-leave-to {
      transform: translateY(-30px);
    }
  }
</style>
